import { render, staticRenderFns } from "./norms.vue?vue&type=template&id=c7418b5c&scoped=true"
import script from "./norms.vue?vue&type=script&lang=js"
export * from "./norms.vue?vue&type=script&lang=js"
import style0 from "./norms.vue?vue&type=style&index=0&id=c7418b5c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7418b5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7418b5c')) {
      api.createRecord('c7418b5c', component.options)
    } else {
      api.reload('c7418b5c', component.options)
    }
    module.hot.accept("./norms.vue?vue&type=template&id=c7418b5c&scoped=true", function () {
      api.rerender('c7418b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/norms/norms.vue"
export default component.exports